import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { SocialProofBar } from '../components/home/SocialProofBar';
import { TodayInSky } from '../components/home/TodayInSky';
import { HowItWorks } from '../components/home/HowItWorks';
import { PopularServices } from '../components/home/PopularServices';
import { WhyAstroGuide } from '../components/home/WhyAstroGuide';
import { PricingSection } from '../components/home/PricingSection';
import { ReportPreviewSection } from '../components/home/ReportPreviewSection';
import { TopAstrologersSection } from '../components/home/TopAstrologersSection';
import { AstroCalendarSection } from '../components/home/AstroCalendarSection';
import { BlogSection } from '../components/home/BlogSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ForAstrologersSection } from '../components/home/ForAstrologersSection';
import { FaqSection } from '../components/home/FaqSection';
import { FinalCtaSection } from '../components/home/FinalCtaSection';
import { SectionErrorBoundary } from '../components/SectionErrorBoundary';
interface HomePageProps {
  onNavigate: (page: string) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <div className="w-full" data-id="element-24677">
      {/* 1. HERO */}
      <SectionErrorBoundary sectionName="HeroBanner" fallbackMinHeight="min-h-screen" data-id="element-24678">
        <HeroBanner onNavigate={onNavigate} data-id="element-24679" />
      </SectionErrorBoundary>

      {/* 2. SOCIAL PROOF BAR */}
      <SectionErrorBoundary sectionName="SocialProofBar" fallbackMinHeight="min-h-[80px]" data-id="element-24680">
        <SocialProofBar data-id="element-24681" />
      </SectionErrorBoundary>

      {/* 3. СЕГОДНЯ В НЕБЕ */}
      <SectionErrorBoundary sectionName="TodayInSky" data-id="element-24682">
        <TodayInSky onNavigate={onNavigate} data-id="element-24683" />
      </SectionErrorBoundary>

      {/* 4. КАК ЭТО РАБОТАЕТ */}
      <SectionErrorBoundary sectionName="HowItWorks" data-id="element-24684">
        <HowItWorks data-id="element-24685" />
      </SectionErrorBoundary>

      {/* 5. ПОПУЛЯРНЫЕ УСЛУГИ */}
      <SectionErrorBoundary sectionName="PopularServices" data-id="element-24686">
        <PopularServices onNavigate={onNavigate} data-id="element-24687" />
      </SectionErrorBoundary>

      {/* 6. ПОЧЕМУ ASTRIQO */}
      <SectionErrorBoundary sectionName="WhyAstroGuide" data-id="element-24688">
        <WhyAstroGuide data-id="element-24689" />
      </SectionErrorBoundary>

      {/* 7. ТАРИФЫ */}
      <SectionErrorBoundary sectionName="PricingSection" data-id="element-24690">
        <PricingSection onNavigate={onNavigate} data-id="element-24691" />
      </SectionErrorBoundary>

      {/* 8. ПРЕВЬЮ ОТЧЁТА */}
      <SectionErrorBoundary sectionName="ReportPreviewSection" data-id="element-24692">
        <ReportPreviewSection onNavigate={onNavigate} data-id="element-24693" />
      </SectionErrorBoundary>

      {/* 9. ТОП АСТРОЛОГИ */}
      <SectionErrorBoundary sectionName="TopAstrologersSection" data-id="element-24694">
        <TopAstrologersSection onNavigate={onNavigate} data-id="element-24695" />
      </SectionErrorBoundary>

      {/* 10. КАЛЕНДАРЬ */}
      <SectionErrorBoundary sectionName="AstroCalendarSection" data-id="element-24696">
        <AstroCalendarSection onNavigate={onNavigate} data-id="element-24697" />
      </SectionErrorBoundary>

      {/* 11. БЛОГ */}
      <SectionErrorBoundary sectionName="BlogSection" data-id="element-24698">
        <BlogSection onNavigate={onNavigate} data-id="element-24699" />
      </SectionErrorBoundary>

      {/* 12. ОТЗЫВЫ */}
      <SectionErrorBoundary sectionName="ReviewsSection" data-id="element-24700">
        <ReviewsSection data-id="element-24701" />
      </SectionErrorBoundary>

      {/* 13. ДЛЯ АСТРОЛОГОВ */}
      <SectionErrorBoundary sectionName="ForAstrologersSection" data-id="element-24702">
        <ForAstrologersSection onNavigate={onNavigate} data-id="element-24703" />
      </SectionErrorBoundary>

      {/* 14. FAQ */}
      <SectionErrorBoundary sectionName="FaqSection" data-id="element-24704">
        <FaqSection data-id="element-24705" />
      </SectionErrorBoundary>

      {/* 15. ФИНАЛЬНЫЙ CTA */}
      <SectionErrorBoundary sectionName="FinalCtaSection" data-id="element-24706">
        <FinalCtaSection data-id="element-24707" />
      </SectionErrorBoundary>
    </div>;
}